import { Component } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ModalSwipeDirective } from '../../../shared/directives/modal-swipe/modal-swipe.directive';
import { OverlaySwipeDirective } from '../../../shared/directives/modal-swipe/overlay-swipe.directive';
import { BottomSwipeSheetDirective } from '../../../shared/directives/modal-swipe/bottom-swipe-sheet.directive';
import { CounterComponent } from '../../../shared/components/counter/counter.component';
import { CurrencyComponent } from '../../../shared/components/price/currency.component';
import { FreshPortionListComponent } from '../components/fresh-portion-list/fresh-portion-list.component';
import { FreshSizePickerComponent } from '../components/fresh-size-picker/fresh-size-picker.component';
import { ModifierListModule } from '../../../components/modifier-list/modifier-list.module';
import { ProductUnitComponent } from '../../../blocks/product-unit/product-unit.component';
import { ProductPriceComponent } from '../../../blocks/product-price/product-price.component';
import { RelatedCardComponent } from '../../../components/related-card/related-card.component';
import { PictureFallbackDirective } from '../../../shared/directives/picture-fallback/picture-fallback.directive';
import { FreshProductInfoPageComponent } from './fresh-product-info-page.component';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { UIMenuItemDto } from '../../../shared/interfaces/ui-menu-item-dto.interface';

@Component({
  selector: 'app-fresh-product-info-page-dynamic',
  templateUrl: './fresh-product-info-page.component.html',
  styleUrls: ['./fresh-product-info-page.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    NgOptimizedImage,
    ReactiveFormsModule,
    ModalSwipeDirective,
    OverlaySwipeDirective,
    BottomSwipeSheetDirective,
    CounterComponent,
    CurrencyComponent,
    FreshPortionListComponent,
    FreshSizePickerComponent,
    ModifierListModule,
    ProductUnitComponent,
    ProductPriceComponent,
    RelatedCardComponent,
    PictureFallbackDirective,
  ]
})
export class FreshProductInfoPageDynamicComponent extends FreshProductInfoPageComponent {
  private _productData: ReplaySubject<UIMenuItemDto> = new ReplaySubject<UIMenuItemDto>(1);
  private _closeModal: Subject<unknown> = new Subject<unknown>();
  closeModalSubj$: Observable<unknown> = this._closeModal.asObservable();

  setProductData(productData: UIMenuItemDto) {
    this._productData.next(productData);
  }

  protected override getProductData(): Observable<UIMenuItemDto> {
    return this._productData.asObservable();
  }

  override closeModal() {
    this._closeModal.next(null);
  }
}
